import HoldingReportPresenter from "@adapters/presenters/Reports/HoldingReport";
import { accountDetails, GTMService } from "@di";
import { DashBoardActions } from "./actions";
import { worker } from "@di";
import abortControllerClass from "@domains/utils/abortControllerClass";
export default (useCases, actions, understandUseCase) => {
    return {
        holdingReport: new HoldingReportPresenter(useCases.holdingReport, useCases.commonHoldings, understandUseCase.understandingSection, actions, useCases.downloadPDFReports, useCases.downloadExcelReports, useCases.sendEmailReports, useCases.dpTransactionUseCase, useCases.dpPullUseCase, useCases.dpTransactionSubmitUseCase, useCases.dpIds, useCases.quoteStream, accountDetails, GTMService, useCases.dashboardHoldingSummaryUseCase, DashBoardActions, worker, new abortControllerClass(new AbortController())),
    };
};
